export const CHEMICAL_DB_API_HOST = import.meta.env.VITE_CHEMICAL_DB_API_BASE_URL;

export const AI_LOAD_API = '/api/mixes/ai-load';

export const JSON_HEADERS = { 'Content-Type': 'application/json' };
